// Helpers partagés pour le rendu "Ta trame" (StudioPage free + StudioPro).
// Mappent chaque fonction de beat et chaque variable sémantique vers une
// instruction CM2 actionable (objectif + à mettre).

export const BEAT_GUIDE = {
  'Accroche':       { objectif: 'Faire stopper le scroll',                 aMettre: 'Une phrase choc, une question ou un fait surprenant' },
  'Hook':           { objectif: 'Faire stopper le scroll',                 aMettre: 'Une phrase choc, une question ou un fait surprenant' },
  'Agitation':      { objectif: 'Toucher un point sensible',               aMettre: 'Une frustration concrète que vit ton audience' },
  'Contexte':       { objectif: 'Planter le décor en 1 phrase',            aMettre: 'Où, quand, qui, sans rentrer dans les détails' },
  'Buildup':        { objectif: 'Faire monter la tension',                 aMettre: 'Une promesse + un teaser sans tout révéler' },
  'Pivot':          { objectif: 'Retourner le viewer',                     aMettre: 'Le twist, le truc inattendu qui change tout' },
  'Punchline':      { objectif: 'Terminer fort',                           aMettre: 'Une phrase percutante qui reste en tête' },
  'Solution':       { objectif: 'Apporter la valeur',                      aMettre: 'Le truc concret que ton audience peut appliquer' },
  'Preuve':         { objectif: 'Crédibiliser ce que tu dis',              aMettre: 'Un chiffre, un témoignage, un avant/après' },
  'Objection':      { objectif: 'Anticiper la réticence',                  aMettre: 'Le "oui mais..." que pense ton viewer + ta réponse' },
  'CTA':            { objectif: 'Faire passer à l\'action',                aMettre: 'Une instruction claire (commente, follow, partage, DM)' },
  'Boucle':         { objectif: 'Ramener au début pour relancer',          aMettre: 'Reformule ta promesse de départ, sans répéter' },
  'Item':           { objectif: 'Donner un élément de la liste',           aMettre: 'Un seul point clair, court, indépendant des autres' },
  'Verdict':        { objectif: 'Donner ton avis tranché',                 aMettre: 'Ton positionnement clair, sans nuances inutiles' },
  'Recap':          { objectif: 'Récapituler les points clés',             aMettre: 'Les 2-3 idées essentielles en quelques mots' },
  'Reaction':       { objectif: 'Montrer ton émotion',                     aMettre: 'Ta vraie réaction, expressions visage, voix vivante' },
}

export function beatGuide(fonction) {
  if (!fonction) return { objectif: 'À toi de jouer', aMettre: 'Ton contenu personnalisé' }
  return BEAT_GUIDE[fonction] || { objectif: fonction, aMettre: 'À toi de remplir' }
}

export const VARIABLE_HINT = {
  'chiffre_cle':             'un chiffre marquant (ex : "100 000 vues")',
  'delai_court':             'un délai court (ex : "7 jours")',
  'delai_moyen':             'un délai moyen (ex : "1 mois")',
  'delai_long':              'un délai long (ex : "1 an")',
  'douleur_quotidienne':     'la frustration que vit ton audience',
  'peur_profonde':           'la peur cachée de ton audience',
  'desir_tangible':          'ce que ton audience veut vraiment',
  'desir_identitaire':       'qui ton audience veut devenir',
  'vehicule_solution':       'ta méthode, ce qui te rend unique',
  'levier_autorite':         'ta preuve de crédibilité',
  'ennemi_visible':          'ce qui empêche ton audience d\'avancer',
  'ennemi_systemique':       'le système contre ton audience',
  'ennemi_interieur':        'le doute intérieur de ton audience',
  'tribu_identitaire':       'le groupe auquel ton audience appartient',
  'tribu_aspirationnelle':   'le groupe qu\'ils veulent rejoindre',
  'emotion_dominante':       'l\'émotion à toucher',
  'preuve_credibilite':      'une preuve concrète (chiffre, témoignage)',
  'preuve_sociale':          'une preuve sociale (avis, exemple)',
  'mauvaise_habitude':       'une mauvaise habitude commune',
  'bonne_pratique':          'une bonne pratique à adopter',
  'transformation':          'un avant / après concret',
  'methode_technique':       'une méthode ou technique précise',
  'objet_quotidien':         'un objet du quotidien',
  'celebrite_reference':     'une célébrité ou figure connue',
  'animal':                  'un animal en référence',
  'autorite_scientifique':   'une étude ou autorité scientifique',
  'qualificatif_negatif':    'un mot négatif fort',
  'qualificatif_positif':    'un mot positif fort',
  'superlatif_exclusivite':  'un superlatif (le meilleur, le plus, l\'unique)',
}

export function variableHint(varName) {
  if (!varName) return null
  return VARIABLE_HINT[varName] || varName.replace(/_/g, ' ')
}

// ─── Map des techniques narratives (depuis analyse Claude) ─────
// 14 techniques répertoriées dans structure_narrative. Chaque technique
// = consigne CM2 sur comment l'exécuter concrètement.
export const TECHNIQUE_HINT = {
  'Question rhétorique':  'Pose une question dont la réponse est évidente (mais on veut que ton viewer y pense)',
  'Statistique':          'Sors un chiffre qui surprend et crédibilise',
  'Storytelling':         'Raconte une vraie histoire courte (héros, problème, transformation)',
  'Provocation':          'Dis un truc qui dérange, qui pousse à réagir',
  'Contraste':            'Oppose 2 idées contradictoires (avant/après, A vs B)',
  'Démonstration':        'Montre concrètement (action, exemple visuel)',
  'Témoignage':           'Rapporte un cas réel (toi ou quelqu\'un)',
  'Appel direct':         'Parle au viewer comme à un pote (« toi », « tu »)',
  'Énumération':          'Liste rapidement plusieurs points (sans détailler)',
  'Confession':           'Avoue un truc personnel ou un échec',
  'Analogie':             'Compare à quelque chose de simple à imaginer',
  'Citation':             'Cite une autorité, une référence connue',
  'Impératif':            'Donne un ordre clair (verbe d\'action en début)',
  'Mise en situation':    'Plante un scénario que ton viewer reconnaît',
}

export function techniqueHint(technique) {
  if (!technique) return null
  return TECHNIQUE_HINT[technique] || null
}

// ─── Map des seaux émotionnels (le levier activé chez le viewer) ─────
// 20 seaux possibles, mappés à ce qu'ils déclenchent côté viewer.
export const SEAU_HINT = {
  'tribu_identitaire':      { label: 'Identité',         text: 'Ton viewer se reconnaît dans un groupe (« c\'est moi ça »)' },
  'tribu_aspirationnelle':  { label: 'Aspiration',       text: 'Ton viewer voit la version de lui qu\'il veut devenir' },
  'ennemi_visible':         { label: 'Ennemi visible',   text: 'Tu nommes ce qui empêche ton viewer d\'avancer' },
  'ennemi_systemique':      { label: 'Ennemi systémique',text: 'Tu attaques un système contre lequel ton viewer rage' },
  'ennemi_interieur':       { label: 'Doute interne',    text: 'Tu touches le doute caché que ton viewer a sur lui-même' },
  'douleur_quotidienne':    { label: 'Douleur quotidienne', text: 'Tu touches la frustration qu\'il vit tous les jours' },
  'peur_profonde':          { label: 'Peur profonde',    text: 'Tu actives une peur cachée (perdre, échouer, être seul)' },
  'honte_secrete':          { label: 'Honte secrète',    text: 'Tu nommes un truc qu\'il n\'ose pas dire à voix haute' },
  'desir_tangible':         { label: 'Désir tangible',   text: 'Tu montres ce qu\'il veut vraiment (résultat concret)' },
  'desir_identitaire':      { label: 'Désir identitaire',text: 'Tu lui fais voir qui il pourrait devenir' },
  'emotion_dominante':      { label: 'Émotion',          text: 'Tu déclenches une émotion forte (surprise, peur, joie)' },
  'vehicule_solution':      { label: 'Solution',         text: 'Tu prouves que ta méthode est la bonne' },
  'levier_autorite':        { label: 'Autorité',         text: 'Tu te positionnes en expert crédible' },
  'preuve_credibilite':     { label: 'Preuve',           text: 'Tu sors une preuve solide (chiffre, témoignage)' },
  'preuve_sociale':         { label: 'Preuve sociale',   text: 'Tu montres que d\'autres l\'ont déjà fait/aimé' },
  'urgence_rarete':         { label: 'Urgence',          text: 'Tu lui dis « c\'est maintenant ou jamais »' },
  'curiosite_gap':          { label: 'Curiosité',        text: 'Tu crées un gap d\'info pour qu\'il VEUILLE la suite' },
  'nostalgie':              { label: 'Nostalgie',        text: 'Tu actives un souvenir partagé' },
  'mecanisme_viral':        { label: 'Viralité',         text: 'Tu déclenches un partage spontané' },
  'resultat_contre_intuitif':{label: 'Surprise',         text: 'Tu casses une attente, l\'effet est mémorable' },
}

export function seauHint(seau) {
  if (!seau) return null
  return SEAU_HINT[seau] || null
}

// Extrait juste l'essentiel de description_visuelle (le 1er plan en bref).
// Format brut : "1 plan(s) :\n  Plan 1 (1.5s) : plan moyen / face camera / fixe — ..."
// → "Plan moyen face caméra fixe"
export function summarizeVisual(descVis) {
  if (!descVis) return null
  // Match "Plan N (Ms) : type / angle / mouvement — texte"
  const m = descVis.match(/Plan\s*\d+\s*\(?[^)]*\)?\s*:\s*([^—\n]+)/i)
  if (m) {
    return m[1].replace(/\//g, ' ').replace(/\s+/g, ' ').trim()
  }
  return descVis.substring(0, 60).trim() + (descVis.length > 60 ? '...' : '')
}

// Composant : rend la liste de beats comme une trame structurée.
// Réutilisable dans StudioPage (free) ET StudioPro (paid).
import React from 'react'

export function TrameContent({ beats, mode }) {
  if (!beats || beats.length === 0) {
    return (
      <p className="text-[11px] text-ink-faint italic py-2">
        Trame indisponible pour ce format.
      </p>
    )
  }
  // Vérité montage : un texte FIXE/empilé n'est pas une suite de plans à filmer.
  // On l'explique et on masque les keyframes redondantes (frames identiques).
  const isStatic = mode === 'fixe' || mode === 'cumulatif' || mode === 'sous-titres'
  const MODE_NOTE = {
    fixe: "Un seul plan. Le texte est affiché en entier dès le départ : les lignes ci-dessous, c'est l'écriture, pas des plans à filmer.",
    cumulatif: 'Un seul plan. Les lignes de texte s\'ajoutent une à une à l\'écran.',
    sequentiel: 'Le texte apparaît ligne par ligne, au rythme de la vidéo.',
    'sous-titres': 'Sous-titres synchronisés à la voix.',
  }
  const headerLabel = isStatic
    ? `Le texte à l'écran (${beats.length} ligne${beats.length > 1 ? 's' : ''})`
    : `${beats.length} étape${beats.length > 1 ? 's' : ''} à filmer dans ton style`
  return (
    <>
      <p className="text-[10px] font-bold mb-2 flex items-center gap-1.5"
        style={{ color: '#7c3aed' }}>
        <span style={{ fontSize: '11px' }}>📐</span>
        {headerLabel}
      </p>
      {mode && MODE_NOTE[mode] && (
        <div className="text-[10.5px] leading-snug mb-2.5 px-2.5 py-1.5 rounded-md flex items-start gap-1.5"
          style={{ background: 'rgba(124,58,237,0.06)', color: '#5b21b6', border: '1px solid rgba(124,58,237,0.15)' }}>
          <span>🎬</span><span>{MODE_NOTE[mode]}</span>
        </div>
      )}
      <ol className="space-y-3">
        {beats.map((b, bi) => {
          const g = beatGuide(b.fonction)
          const varH = variableHint(b.variable_cle)
          const techH = techniqueHint(b.technique)
          const seauH = seauHint(b.seau_active)
          const visualSummary = summarizeVisual(b.description_visuelle)
          const exemple = b.valeur_variable && String(b.valeur_variable).trim()
          const hasFullDesc = b.description_visuelle && b.description_visuelle.length > 80
          return (
            <li key={bi} className="rounded-lg overflow-hidden"
              style={{ background: 'rgba(124,58,237,0.04)', border: '1px solid rgba(124,58,237,0.12)' }}>
              <div className="flex items-start gap-2.5 p-2.5">
                {/* Keyframe miniature si dispo, sinon numéro */}
                {b.image_cle_url && (!isStatic || bi === 0) ? (
                  <div className="shrink-0 relative w-12 h-16 sm:w-14 sm:h-20 rounded overflow-hidden border border-white/30"
                    style={{ background: '#1e1145' }}>
                    <img src={b.image_cle_url} alt={`Beat ${b.beat}`}
                      className="absolute inset-0 w-full h-full object-cover"
                      loading="lazy"
                      onError={(e) => { e.currentTarget.style.display = 'none' }} />
                    <span className="absolute top-0.5 left-0.5 inline-flex items-center justify-center w-4 h-4 rounded-full text-[8px] font-bold text-white"
                      style={{ background: 'rgba(124,58,237,0.95)' }}>
                      {b.beat || bi + 1}
                    </span>
                  </div>
                ) : (
                  <span className="shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold text-white mt-0.5"
                    style={{ background: 'linear-gradient(135deg, #7c3aed, #5b21b6)' }}>
                    {b.beat || bi + 1}
                  </span>
                )}

                <div className="min-w-0 flex-1 space-y-1.5">
                  {/* Fonction + badges technique + seau */}
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="text-[11.5px] font-bold" style={{ color: '#5b21b6' }}>
                      {b.fonction || `Étape ${bi + 1}`}
                    </span>
                    {b.technique && (
                      <span className="text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded"
                        style={{ background: 'rgba(254,130,4,0.10)', color: '#d97206', border: '1px solid rgba(254,130,4,0.20)' }}>
                        {b.technique}
                      </span>
                    )}
                    {seauH?.label && (
                      <span className="text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded"
                        style={{ background: 'rgba(16,185,129,0.08)', color: '#047857', border: '1px solid rgba(16,185,129,0.20)' }}>
                        ♥ {seauH.label}
                      </span>
                    )}
                  </div>

                  {/* Objectif (ce que tu veux obtenir) */}
                  <div className="text-[10.5px] leading-snug">
                    <span className="text-ink-faint">Objectif : </span>
                    <span className="text-ink">{g.objectif}</span>
                  </div>

                  {/* Levier émotionnel : ce que tu actives chez le viewer */}
                  {seauH?.text && (
                    <div className="text-[10.5px] leading-snug">
                      <span className="text-ink-faint">Transmet : </span>
                      <span className="text-ink">{seauH.text}</span>
                    </div>
                  )}

                  {/* Comment l'exécuter (technique) */}
                  {techH && (
                    <div className="text-[10.5px] leading-snug">
                      <span className="text-ink-faint">Comment : </span>
                      <span className="text-ink">{techH}</span>
                    </div>
                  )}

                  {/* À mettre : consigne TRANSPOSÉE à la niche du user quand
                      l'adaptation l'a produite, sinon taxonomie source reformulée
                      en consigne ("Ton équivalent de...") au lieu du label brut */}
                  <div className="text-[10.5px] leading-snug">
                    <span className="text-ink-faint">À mettre : </span>
                    <span className="text-ink">{b.a_mettre_adapte ? b.a_mettre_adapte : (varH ? `ton équivalent de « ${varH.toLowerCase()} »` : g.aMettre)}</span>
                  </div>
                  {b.exemple_persona && (
                    <p className="text-[10px] leading-snug" style={{ color: '#d97206' }}>
                      ✨ Pour toi : <span className="font-medium">"{String(b.exemple_persona).substring(0, 90)}"</span>
                    </p>
                  )}

                  {/* Exemple concret depuis la source */}
                  {exemple && (
                    <p className="text-[10px] text-ink-faint leading-snug italic">
                      💡 Exemple source : <span className="text-ink-muted not-italic">"{exemple.substring(0, 80)}{exemple.length > 80 ? '...' : ''}"</span>
                    </p>
                  )}

                  {/* Cadrage suggéré : juste 1 ligne courte, pas de clic, pas d'expand */}
                  {visualSummary && (
                    <p className="text-[10px] text-ink-faint">🎥 Cadrage : {visualSummary}</p>
                  )}
                </div>
              </div>
            </li>
          )
        })}
      </ol>
      <p className="text-[10px] text-ink-faint italic mt-3 pt-2 border-t border-orange/10">
        À toi de filmer chaque étape avec ta voix, ton vocabulaire, ton humour. La structure et le levier émotionnel sont validés par les vues source, le contenu reste le tien.
      </p>
    </>
  )
}
